// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".as-link[data-v-a8d81d9a]{cursor:pointer}.max-100 img[data-v-a8d81d9a]{max-width:100%;max-height:100%}", ""]);
// Exports
module.exports = exports;
